import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { BookingStatus, DateUtility } from '@jms/model';
import { JmsValidators } from '@jms/utils/util.validators';

import { AllocationEditFormInput } from '../model';
import { AllocationUtility } from './allocation.utility';

export class AllocationFormHelper {

    public static getAllocationGroup(allocation: AllocationEditFormInput, timezone: string): UntypedFormGroup {

        const startDate = allocation
            ? DateUtility.getDateTime(allocation.startDate, timezone)
            : null;

        const endDate = allocation
            ? DateUtility.getDateTime(allocation.endDate, timezone)
            : null;

        allocation = allocation ?? {} as any;

        type AllocationEditFormInputExtend = AllocationEditFormInput & { isShadow: boolean, defaultDate: Date }

        type AllocationEditForm = Partial<
            Record<
                keyof AllocationEditFormInputExtend,
                (any | ((control: AbstractControl<any, any>) => ValidationErrors)[])[]
            >
        >;

        const group: AllocationEditForm = {
            _id: [allocation._id, []],
            run: [allocation.run, []],
            resource: [allocation?.resource, [Validators.required]],
            contractorResource: [allocation?.contractorResource, []],
            startDate: [startDate, [Validators.required]],
            endDate: [endDate, [Validators.required]],
            status: [allocation.status, []],
            booking: [allocation.booking, []],
            job: [allocation.job, []],
            note: [allocation.note, []],
            workOrder: [allocation.workOrder, []],
            site: [allocation.site, []],
            overhead: [allocation.overhead, []],
            clusterColor: [allocation.clusterColor, []],
            createdAt: [allocation.createdAt, []],
            updatedAt: [allocation.updatedAt, []],
            source: [allocation.source, []],
            additionalDays: [allocation.additionalDays, [Validators.min(0), Validators.max(10), Validators.pattern(JmsValidators.getNumberPattern())]],
            opportunity: [allocation.opportunity, []],
            bookingStatus: [allocation.bookingStatus ?? BookingStatus.Confirmed, []],
            isShadow: [AllocationUtility.isShadow(allocation), []],
            locked: [allocation.locked, []],
            allDay: [allocation.allDay, []],
            statusInfo: [allocation.statusInfo, []],
            rule: [allocation.rule, []],
            parentId: [allocation.parentId, []],
            isConflict: [allocation.isConflict, []],

            editCategory: [allocation.editCategory, []],
            hide: [allocation.hide, []],
            canRecurrence: [allocation.canRecurrence, []]
        }


        const builder = new UntypedFormBuilder();

        return builder.group(group);
    }


    public static getNewAllocationGroup(): UntypedFormGroup {

        const builder = new UntypedFormBuilder();

        return builder.group({
            resources: [null, [Validators.required]],
            startDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            note: [null, []],
            additionalDays: [null, [Validators.min(0), Validators.max(10), Validators.pattern(JmsValidators.getNumberPattern())]],
            bookingStatus: [BookingStatus.Confirmed, []],
        });
    }
}